import { LuList } from "react-icons/lu";

import {
  BulletListEmailRenderer,
  ListItemEmailRenderer,
  OrderedListEmailRenderer,
} from "./email-renderer";

/**
 * List blocks are special — they use standard Tiptap list extensions
 * (BulletList, OrderedList, ListItem) rather than our custom block
 * definition pattern. These exports provide metadata for the block
 * picker and email renderers for the converter.
 */
export const listBlockMeta = {
  label: "List",
  icon: LuList,
  category: "content" as const,
};

export const listEmailRenderers = {
  bulletList: BulletListEmailRenderer,
  orderedList: OrderedListEmailRenderer,
  listItem: ListItemEmailRenderer,
};
